import styled from '@emotion/styled';
import { Color } from 'views/constants';

export const Driver = styled.div`
  border-bottom: 1px solid ${Color.C14};
`;
